import React, { Component } from 'react'
import { connect } from 'react-redux'

import { bindActionCreators } from 'redux'

import { toggleRoleSection, pinParticipationElement, roleSetClickedElement } from './actions'

export function mapStateToProps(state, props) {
    const { mainId } = props
    const openSections = state.getIn(
        ['ui', 'workspace', 'report', mainId, 'blocks', 'rolesInCompanies', 'customData', 'openSections'],
        {}
    )
    const pinnedIndex = state.getIn(
        ['ui', 'workspace', 'report', mainId, 'blocks', 'rolesInCompanies', 'customData', 'pinnedIndex'],
        null
    )
    const clickedElement = state.getIn(
        ['ui', 'workspace', 'report', mainId, 'blocks', 'rolesInCompanies', 'customData', 'clickedElement'],
        {}
    )

    return {
        openSections,
        pinnedIndex,
        clickedElement,
        locale: state.getIn(['translate', 'locale']),
    }
}

export const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            toggleRoleSection,
            pinParticipationElement,
            roleSetClickedElement,
        },
        dispatch
    )

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
